<div class="p-4">
  <p-steps *ngIf="(isHandset$ | async) === false" [model]="items" [readonly]="false" styleClass="mb-4"
    [activeIndex]="activeIndex">
  </p-steps>

  <div *ngIf="isHandset$ | async" class="flex gap-3 items-center mb-4">
    <span class="w-8 h-8 rounded-full bg-green-700 text-white flex align-middle items-center justify-center">
      {{ activeIndex+1 }}
    </span>
    <h3 class="text-xl font-semibold">{{ items[activeIndex]?.label }}</h3>
  </div>

  <div *ngIf="activeIndex === 0">
    <div class="flex flex-col gap-6 items-center py-8">
      <div class="flex flex-col items-center gap-4">
        <img class="w-48 h-auto" src="assets/img/logo.png" alt="Ekowitryna ESG" />
        <h2 class="text-2xl font-bold text-center text-gray-800 dark:text-gray-100">{{ 'firstConfiguration.welcomeTitle' | translate }}</h2>
      </div>
      <div class="text-center text-gray-600 dark:text-gray-300 max-w-2xl px-4 leading-relaxed flex flex-col gap-4">
        <p>{{ 'firstConfiguration.welcomeText1' | translate }}</p>
        <p>{{ 'firstConfiguration.welcomeText2' | translate }}</p>
        <p>{{ 'firstConfiguration.welcomeText3' | translate }}</p>
      </div>
      <p-button (onClick)="onNext()" severity="primary" class="mt-4" icon="pi pi-arrow-right" iconPos="right"
        [label]="'firstConfiguration.startButton' | translate" />
    </div>
  </div>

  <div *ngIf="activeIndex === 1">
    <p class="mb-8">{{ 'firstConfiguration.step1.description' | translate }}</p>
    <form [formGroup]="accountForm" class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <label for="nipNumber">
          {{ 'firstConfiguration.nip.label' | translate }}
          <span *ngIf="isRequired(accountForm, 'nipNumber')" title="required" class="text-red-600">*</span>
        </label>
        <input type="text" pInputText [disabled]="accountFormLoading" formControlName="nipNumber" id="nipNumber"
          class="w-full" maxlength="10" inputmode="numeric" />
        <small class="text-red-500"
          *ngIf="!accountForm.controls['nipNumber'].valid && accountForm.controls['nipNumber'].touched">
          {{ getError(accountForm, 'nipNumber') }}
        </small>
      </div>

      <div class="flex flex-col gap-2">
        <label for="companyName">
          {{ 'firstConfiguration.companyName.label' | translate }}
          <span *ngIf="isRequired(accountForm, 'companyName')" title="required" class="text-red-600">*</span>
        </label>
        <input type="text" pInputText [disabled]="accountFormLoading" formControlName="companyName" id="companyName"
          class="w-full" />
        <small class="text-red-500"
          *ngIf="!accountForm.controls['companyName'].valid && accountForm.controls['companyName'].touched">
          {{ getError(accountForm, 'companyName') }}
        </small>
      </div>

      <div class="flex flex-col gap-2">
        <label for="address">
          {{ 'firstConfiguration.address.label' | translate }}
          <span *ngIf="isRequired(accountForm, 'address')" title="required" class="text-red-600">*</span>
        </label>
        <input type="text" pInputText [disabled]="accountFormLoading" formControlName="address" id="address"
          class="w-full" />
        <small class="text-red-500"
          *ngIf="!accountForm.controls['address'].valid && accountForm.controls['address'].touched">
          {{ getError(accountForm, 'address') }}
        </small>
      </div>

      <div class="flex flex-col gap-2">
        <label for="postCode">
          {{ 'firstConfiguration.postCode.label' | translate }}
          <span *ngIf="isRequired(accountForm, 'postCode')" title="required" class="text-red-600">*</span>
        </label>
        <input type="text" pInputText [disabled]="accountFormLoading" formControlName="postCode" id="postCode"
          class="w-full" maxlength="6" inputmode="numeric" />
        <small class="text-red-500"
          *ngIf="!accountForm.controls['postCode'].valid && accountForm.controls['postCode'].touched">
          {{ getError(accountForm, 'postCode') }}
        </small>
      </div>

      <div class="flex flex-col gap-2">
        <label for="city">
          {{ 'firstConfiguration.city.label' | translate }}
          <span *ngIf="isRequired(accountForm, 'city')" title="required" class="text-red-600">*</span>
        </label>
        <input type="text" pInputText [disabled]="accountFormLoading" formControlName="city" id="city"
          class="w-full" />
        <small class="text-red-500"
          *ngIf="!accountForm.controls['city'].valid && accountForm.controls['city'].touched">
          {{ getError(accountForm, 'city') }}
        </small>
      </div>

      <div class="flex flex-col gap-2">
        <label for="marketingSource">
          {{ 'firstConfiguration.marketingSource.label' | translate }}
          <span *ngIf="isRequired(accountForm, 'marketingSource')" title="required" class="text-red-600">*</span>
        </label>
        <p-select [options]="marketingSource" formControlName="marketingSource" styleClass="w-full" required
          appendTo="body"></p-select>
      </div>

      <div *ngIf="accountForm.controls['marketingSource'].value === 'Inne'" class="flex flex-col gap-2">
        <label for="marketingSourceOther">
          {{ 'firstConfiguration.marketingSourceOther.label' | translate }}
          <span *ngIf="isRequired(accountForm, 'marketingSourceOther')" title="required" class="text-red-600">*</span>
        </label>
        <input type="text" [disabled]="accountFormLoading" pInputText formControlName="marketingSourceOther"
          class="w-full" [required]="accountForm.controls['marketingSource'].value === 'Inne'" />
        <small class="text-red-500"
          *ngIf="!accountForm.controls['marketingSourceOther'].valid && accountForm.controls['marketingSourceOther'].touched">
          {{ getError(accountForm, 'marketingSourceOther') }}
        </small>
      </div>

      <div class="flex gap-2 items-center">
        <p-checkbox formControlName="marketingAgreement" [binary]="true" inputId="checkboxMarketing"></p-checkbox>
        <label for="checkboxMarketing" class="ml-2">
          {{ 'firstConfiguration.newsletterAgreement' | translate }}
        </label>
      </div>

      <!-- Error message -->
      <div *ngIf="accountFormError" class="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 p-4 rounded-r">
        <div class="flex items-center gap-3">
          <i class="pi pi-exclamation-triangle text-red-500"></i>
          <p class="text-red-700 dark:text-red-300">{{ accountFormError }}</p>
        </div>
      </div>

      <!-- Button -->
      <div class="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button
          type="button"
          class="w-full px-6 py-3 rounded-lg font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 dark:from-primary-500 dark:to-primary-600 dark:hover:from-primary-600 dark:hover:to-primary-700 shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-md group"
          (click)="saveAccountForm()"
          [disabled]="!accountForm.valid || accountFormLoading">
          <span *ngIf="!accountFormLoading">{{ 'firstConfiguration.saveButton' | translate }}</span>
          <span *ngIf="accountFormLoading">{{ 'firstConfiguration.saving' | translate }}</span>
          <i *ngIf="!accountFormLoading" class="pi pi-arrow-right text-sm group-hover:translate-x-1 transition-transform duration-200"></i>
          <i *ngIf="accountFormLoading" class="pi pi-spinner pi-spin text-sm"></i>
        </button>
      </div>
    </form>
  </div>


  <div *ngIf="activeIndex === 2">
    <div class="flex flex-col gap-6">
      <div class="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-500 p-4 rounded-r">
        <div class="flex items-start gap-3">
          <i class="pi pi-info-circle text-blue-500 text-xl mt-1"></i>
          <div class="flex-1">
            <p class="text-gray-800 dark:text-gray-200">
              {{ 'firstConfiguration.step3.description' | translate }}
            </p>
          </div>
        </div>
      </div>

      <app-create-company-instructions />

      <form [formGroup]="credentialsForm" class="flex flex-col gap-6 mt-4">
        <div class="grid grid-cols-1 gap-6">
          <div class="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
            <div class="flex items-start gap-3">
              <p-checkbox formControlName="nameFromBdo" binary="true" (onChange)="onChangeNameFromBdo($event)" inputId="nameFromBdo"></p-checkbox>
              <label for="nameFromBdo" class="text-gray-700 dark:text-gray-200 cursor-pointer flex-1">
                {{ 'firstConfiguration.step3.nameFromBdo' | translate }}
              </label>
            </div>
          </div>

          <!-- Nazwa firmy -->
          <div class="flex flex-col gap-2">
            <label for="name" class="font-semibold text-gray-700 dark:text-gray-200">
              {{ 'firstConfiguration.step3.companyName' | translate }}
              <span *ngIf="isRequired(credentialsForm, 'name')" title="required" class="text-red-500 ml-1">*</span>
            </label>
            <input type="text" pInputText formControlName="name"
                   class="w-full"
                   [ngClass]="{'p-invalid': !credentialsForm.controls['name'].valid && credentialsForm.controls['name'].touched}" />
            <small class="text-red-500" *ngIf="!credentialsForm.controls['name'].valid && credentialsForm.controls['name'].touched">
              {{ getError(credentialsForm, 'name') }}
            </small>
            <small class="text-blue-600 dark:text-blue-400 flex items-center gap-1" *ngIf="isAuto()">
              <i class="pi pi-check-circle text-xs"></i>
              {{ 'firstConfiguration.step3.nameAuto' | translate }}
            </small>
          </div>

          <!-- NIP -->
          <div class="flex flex-col gap-2">
            <label for="nip" class="font-semibold text-gray-700 dark:text-gray-200">
              {{ 'firstConfiguration.step3.nip' | translate }}
              <span *ngIf="isRequired(credentialsForm, 'nip')" title="required" class="text-red-500 ml-1">*</span>
            </label>
            <input type="text" pInputText formControlName="nip"
                   class="w-full"
                   [ngClass]="{'p-invalid': !credentialsForm.controls['nip'].valid && credentialsForm.controls['nip'].touched}" />
            <small class="text-red-500" *ngIf="!credentialsForm.controls['nip'].valid && credentialsForm.controls['nip'].touched">
              {{ getError(credentialsForm, 'nip') }}
            </small>
            <small class="text-blue-600 dark:text-blue-400 flex items-center gap-1" *ngIf="isAuto()">
              <i class="pi pi-check-circle text-xs"></i>
              {{ 'firstConfiguration.step3.nipAuto' | translate }}
            </small>
          </div>

          <!-- Client ID -->
          <div class="flex flex-col gap-2">
            <label for="clientId" class="font-semibold text-gray-700 dark:text-gray-200">
              {{ 'firstConfiguration.step3.clientId' | translate }}
              <span *ngIf="isRequired(credentialsForm, 'clientId')" title="required" class="text-red-500 ml-1">*</span>
            </label>
            <input type="text" pInputText formControlName="clientId"
                   class="w-full font-mono text-sm"
                   [ngClass]="{'p-invalid': !credentialsForm.controls['clientId'].valid && credentialsForm.controls['clientId'].touched}" />
            <small class="text-red-500" *ngIf="!credentialsForm.controls['clientId'].valid && credentialsForm.controls['clientId'].touched">
              {{ getError(credentialsForm, 'clientId') }}
            </small>
          </div>

          <!-- Client Secret -->
          <div class="flex flex-col gap-2">
            <label for="clientSecret" class="font-semibold text-gray-700 dark:text-gray-200">
              {{ 'firstConfiguration.step3.clientSecret' | translate }}
              <span *ngIf="isRequired(credentialsForm, 'clientSecret')" title="required" class="text-red-500 ml-1">*</span>
            </label>
            <input type="text" pInputText formControlName="clientSecret"
                   class="w-full font-mono text-sm"
                   [ngClass]="{'p-invalid': !credentialsForm.controls['clientSecret'].valid && credentialsForm.controls['clientSecret'].touched}" />
            <small class="text-red-500" *ngIf="!credentialsForm.controls['clientSecret'].valid && credentialsForm.controls['clientSecret'].touched">
              {{ getError(credentialsForm, 'clientSecret') }}
            </small>
          </div>
        </div>

        <!-- Error message -->
        <div *ngIf="credentialsFormError" class="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 p-4 rounded-r">
          <div class="flex items-center gap-3">
            <i class="pi pi-exclamation-triangle text-red-500"></i>
            <p class="text-red-700 dark:text-red-300">{{ credentialsFormError }}</p>
          </div>
        </div>

        <!-- Buttons -->
        <div class="flex flex-col sm:flex-row gap-4 mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
          <button
            type="button"
            class="flex-1 px-6 py-3 rounded-lg font-semibold text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed group"
            (click)="skipCredentialsForm()"
            [disabled]="credentialsFormLoading">
            <span>{{ 'firstConfiguration.step3.skip' | translate }}</span>
            <i class="pi pi-arrow-right text-sm group-hover:translate-x-1 transition-transform duration-200"></i>
          </button>
          <button
            type="button"
            class="flex-1 px-6 py-3 rounded-lg font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 dark:from-primary-500 dark:to-primary-600 dark:hover:from-primary-600 dark:hover:to-primary-700 shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-md group"
            (click)="saveCredentialsForm()"
            [disabled]="!credentialsForm.valid || credentialsFormLoading">
            <span *ngIf="!credentialsFormLoading">{{ 'firstConfiguration.saveButton' | translate }}</span>
            <span *ngIf="credentialsFormLoading">{{ 'firstConfiguration.saving' | translate }}</span>
            <i *ngIf="!credentialsFormLoading" class="pi pi-check text-sm group-hover:scale-110 transition-transform duration-200"></i>
            <i *ngIf="credentialsFormLoading" class="pi pi-spinner pi-spin text-sm"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
  


  <div *ngIf="activeIndex === 3" class="flex flex-col gap-6 items-center py-8">
    <div class="flex flex-col items-center gap-4">
      <img class="w-48 h-auto" src="assets/img/logo.png" alt="Ekowitryna ESG" />
      <h2 class="text-2xl font-bold text-center text-gray-800 dark:text-gray-100">{{ 'firstConfiguration.step5.title' | translate }}</h2>
    </div>
    <p class="text-center text-gray-600 dark:text-gray-300 max-w-2xl px-4 leading-relaxed">
      {{ 'firstConfiguration.step5.description' | translate }}
    </p>
    <div class="flex flex-col items-center gap-6 mt-4 w-full max-w-2xl px-4">
      <a [href]="playStoreUrl" target="_blank" rel="noopener noreferrer" class="inline-block hover:opacity-90 transition-opacity">
        <img src="assets/img/google-play-badge.svg" alt="Pobierz z Google Play" class="h-14 w-auto" />
      </a>
      <button
        type="button"
        class="w-full px-6 py-3 rounded-lg font-semibold text-white bg-green-600 hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600 shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 group"
        (click)="finish()">
        <span>{{ 'firstConfiguration.step5.finishButton' | translate }}</span>
        <i class="pi pi-check text-sm group-hover:scale-110 transition-transform duration-200"></i>
      </button>
    </div>
  </div>
  
</div>